function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable react/prop-types */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import dynamic from 'next/dynamic';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { renderContentfulComponent } from './contentful';
import RichText from '../components/rich-text';
import { constructSizes } from '../components/image';
import Button, { buttonKinds } from '../components/button';
import DynamicIcon from '../components/icons/dynamic-icon';
import ForwardedRefVideoPlayer from '../components/video-player/forwarded-ref-video-player';
var Accordion = dynamic(() => import('../components/accordion'));
var AccordionItem = dynamic(() => import('../components/accordion-item'));
var BrandStatement = dynamic(() => import('../components/brand-statement'));
var CampaignHero = dynamic(() => import('../components/campaign-hero'));
var Card = dynamic(() => import('../components/card'));
var CTABlock = dynamic(() => import('../components/cta-block'));
var Footnote = dynamic(() => import('../components/footnote'));
var GridContainer = dynamic(() => import('../components/grid-container'));
var Heading = dynamic(() => import('../components/heading'));
var IconList = dynamic(() => import('../components/iconList'));
var IconListDetailedItem = dynamic(() => import('../components/iconListDetailedItem'));
var Image = dynamic(() => import('../components/image'));
var LaunchFullscreenVideo = dynamic(() => import('../components/launch-fullscreen-video'));
var LinkGenerator = dynamic(() => import('../components/link-generator'));
var MediaActionBlock = dynamic(() => import('../components/media-action-block'));
var ModalLink = dynamic(() => import('../components/modal-link'));
var Notification = dynamic(() => import('../components/notification'));
var Pill = dynamic(() => import('../components/pill'));
var ProductCarousel = dynamic(() => import('../components/product-carousel'));
var Quote = dynamic(() => import('../components/quote'));
var Table = dynamic(() => import('../components/table'));
var Tabpanel = dynamic(() => import('../components/tabpanel'));
var TabpanelPanel = dynamic(() => import('../components/tabpanel/panel'));
export var renderContentType = {
  webComponentModalLink: _ref => {
    var _modal$fields;
    var {
      data: {
        ctaText,
        modal,
        classes
      }
    } = _ref;
    return /*#__PURE__*/React.createElement(ModalLink, {
      linkText: ctaText,
      modalBody: /*#__PURE__*/React.createElement(RichText, {
        body: modal === null || modal === void 0 ? void 0 : (_modal$fields = modal.fields) === null || _modal$fields === void 0 ? void 0 : _modal$fields.body
      }),
      classes: classes
    });
  },
  webAccordion: _ref2 => {
    var {
      data: {
        entryId,
        size,
        version,
        defaultHeadingTypeStyle,
        mobileHeadingTypeStyle
      },
      children
    } = _ref2;
    return /*#__PURE__*/React.createElement(Accordion, {
      id: "accordion-".concat(entryId),
      size: size,
      v2: version === 'v2',
      defaultTypeStyle: defaultHeadingTypeStyle,
      mobileTypeStyle: mobileHeadingTypeStyle
    }, children);
  },
  webAccordionItem: _ref3 => {
    var {
      data: {
        body,
        title
      }
    } = _ref3;
    return /*#__PURE__*/React.createElement(AccordionItem, {
      heading: title
    }, RichText({
      body
    }));
  },
  brandStatement: _ref4 => {
    var _defaultImage$fields, _defaultImage$fields2, _mobileImage$fields, _mobileImage$fields2;
    var {
      contentfulComponent,
      data: {
        callToAction,
        defaultImage,
        heading,
        mobileImage,
        subtitle
      },
      options,
      parents = []
    } = _ref4;
    return /*#__PURE__*/React.createElement(BrandStatement, {
      ctaButton: (callToAction === null || callToAction === void 0 ? void 0 : callToAction.fields) && renderContentfulComponent({
        contentfulComponent: callToAction,
        options,
        parents: [...parents, contentfulComponent]
      }),
      editorialCopy: subtitle,
      headline: heading,
      imageProps: {
        alt: (defaultImage === null || defaultImage === void 0 ? void 0 : (_defaultImage$fields = defaultImage.fields) === null || _defaultImage$fields === void 0 ? void 0 : _defaultImage$fields.imageDescription) || '',
        src: defaultImage === null || defaultImage === void 0 ? void 0 : (_defaultImage$fields2 = defaultImage.fields) === null || _defaultImage$fields2 === void 0 ? void 0 : _defaultImage$fields2.imageUrl
      },
      mobileImageProps: mobileImage && {
        alt: (mobileImage === null || mobileImage === void 0 ? void 0 : (_mobileImage$fields = mobileImage.fields) === null || _mobileImage$fields === void 0 ? void 0 : _mobileImage$fields.imageDescription) || '',
        src: mobileImage === null || mobileImage === void 0 ? void 0 : (_mobileImage$fields2 = mobileImage.fields) === null || _mobileImage$fields2 === void 0 ? void 0 : _mobileImage$fields2.imageUrl
      }
    });
  },
  webButton: _ref5 => {
    var {
      data
    } = _ref5;
    if (data.linkAttributes == null) {
      data.linkAttributes = {
        openNewWindow: false,
        rel: ''
      };
    }
    var {
      callToAction,
      linkAttributes: {
        openNewWindow,
        rel = []
      },
      variant,
      webRoute
    } = data;
    var kind = buttonKinds.includes(variant) ? variant : undefined;
    return /*#__PURE__*/React.createElement(Button, {
      href: webRoute,
      kind: kind,
      rel: rel.length ? rel.join(' ') : null,
      target: openNewWindow ? '_blank' : null,
      mobileBlock: true
    }, callToAction);
  },
  webComponentCampaignHero: _ref6 => {
    var _cta$fields, _cta$fields2, _title$fields, _title$fields2;
    var {
      data: {
        body,
        cta,
        media,
        title
      }
    } = _ref6;
    var {
      autoplay,
      imageDescription,
      imageUrl,
      mobileImageUrl,
      videoCaptionsUrl,
      videoPreviewImageUrl,
      videoUrl
    } = (media === null || media === void 0 ? void 0 : media.fields) || {};

    // Default type is autoplay unless `autoplay` field in Contentful is set to `false`
    var videoPlayerType = 'autoplay';
    if (autoplay === false) {
      videoPlayerType = 'inline';
    }
    return /*#__PURE__*/React.createElement(CampaignHero, {
      body: /*#__PURE__*/React.createElement(RichText, {
        body: body,
        options: {
          transformElement: _ref7 => {
            var {
              element,
              contentType
            } = _ref7;
            if (contentType === 'link') {
              return /*#__PURE__*/React.cloneElement(element, {
                className: 'lll-link-primary'
              });
            }
            return element;
          }
        }
      }),
      buttonHref: cta === null || cta === void 0 ? void 0 : (_cta$fields = cta.fields) === null || _cta$fields === void 0 ? void 0 : _cta$fields.webRoute,
      buttonText: cta === null || cta === void 0 ? void 0 : (_cta$fields2 = cta.fields) === null || _cta$fields2 === void 0 ? void 0 : _cta$fields2.callToAction,
      imageProps: imageUrl && {
        alt: imageDescription || '',
        mobileSrc: mobileImageUrl,
        src: imageUrl
      },
      title: title === null || title === void 0 ? void 0 : (_title$fields = title.fields) === null || _title$fields === void 0 ? void 0 : _title$fields.title,
      titleTag: title === null || title === void 0 ? void 0 : (_title$fields2 = title.fields) === null || _title$fields2 === void 0 ? void 0 : _title$fields2.webHeadingLevel,
      videoProps: videoUrl && {
        captionProps: videoCaptionsUrl ? {
          src: videoCaptionsUrl
        } : null,
        landscapeAdaptiveSource: videoUrl,
        landscapePosterImageProps: videoPreviewImageUrl ? {
          alt: '',
          lazy: true,
          maxWidth: 1300,
          src: videoPreviewImageUrl
        } : null,
        type: videoPlayerType
      }
    });
  },
  webPromoCard: _ref8 => {
    var _contentfulComponent$, _locale$split;
    var {
      contentfulComponent,
      data: {
        aspectRatio: rawAspectRatio = '',
        callToAction,
        ctaText,
        description,
        desktopMedia,
        imageDescription,
        // deprecated
        imageUrl,
        // deprecated
        mobileImageUrl,
        // deprecated
        mobileMedia,
        title,
        webRoute
      }
      // eslint-disable-next-line sonarjs/cognitive-complexity
    } = _ref8;
    // This normalizing the data shape is needed to support the graphql response shapes
    var normalizedDesktopMedia = (desktopMedia === null || desktopMedia === void 0 ? void 0 : desktopMedia.fields) || desktopMedia;
    var normalizedMobileMedia = (mobileMedia === null || mobileMedia === void 0 ? void 0 : mobileMedia.fields) || mobileMedia;
    var hasDefaultImage = (normalizedDesktopMedia === null || normalizedDesktopMedia === void 0 ? void 0 : normalizedDesktopMedia.imageUrl) || imageUrl;
    var hasMobileImage = (normalizedMobileMedia === null || normalizedMobileMedia === void 0 ? void 0 : normalizedMobileMedia.imageUrl) || mobileImageUrl;
    var aspectRatio = rawAspectRatio.toLowerCase();
    var locale = contentfulComponent === null || contentfulComponent === void 0 ? void 0 : (_contentfulComponent$ = contentfulComponent.sys) === null || _contentfulComponent$ === void 0 ? void 0 : _contentfulComponent$.locale;
    var srcLang = locale === null || locale === void 0 ? void 0 : (_locale$split = locale.split('-')) === null || _locale$split === void 0 ? void 0 : _locale$split[0];
    // Default responsive image sizing is based on 3-column wide card
    var DEFAULT_IMAGE_MAX_WIDTH = 624;
    var DEFAULT_IMAGE_SIZES = constructSizes([{
      breakpoint: '1372px',
      slotSize: '312px'
    }, {
      breakpoint: '992px',
      slotSize: '22vw'
    }, {
      breakpoint: '768px',
      slotSize: '21vw'
    }, {
      slotSize: '97vw'
    }]);

    // Landscape responsive image sizing is based on 6-column wide card
    var LANDSCAPE_IMAGE_MAX_WIDTH = 1300;
    var LANDSCAPE_IMAGE_SIZES = constructSizes([{
      breakpoint: '1372px',
      slotSize: '649px'
    }, {
      breakpoint: '992px',
      slotSize: '46vw'
    }, {
      breakpoint: '768px',
      slotSize: '45vw'
    }, {
      slotSize: '97vw'
    }]);
    var MAX_WIDTH = aspectRatio === 'landscape' ? LANDSCAPE_IMAGE_MAX_WIDTH : DEFAULT_IMAGE_MAX_WIDTH;
    var IMAGE_SIZES = aspectRatio === 'landscape' ? LANDSCAPE_IMAGE_SIZES : DEFAULT_IMAGE_SIZES;
    var imageProps;
    var mobileImageProps;
    var videoProps;
    var mobileVideoProps;
    var ctaLinkAs;
    if (hasDefaultImage) {
      imageProps = {
        alt: (normalizedDesktopMedia === null || normalizedDesktopMedia === void 0 ? void 0 : normalizedDesktopMedia.imageDescription) || imageDescription,
        maxWidth: MAX_WIDTH,
        sizes: IMAGE_SIZES,
        src: (normalizedDesktopMedia === null || normalizedDesktopMedia === void 0 ? void 0 : normalizedDesktopMedia.imageUrl) || imageUrl
      };
    }
    if (hasMobileImage) {
      mobileImageProps = {
        alt: (normalizedMobileMedia === null || normalizedMobileMedia === void 0 ? void 0 : normalizedMobileMedia.imageDescription) || imageDescription,
        maxWidth: 1300,
        sizes: constructSizes([{
          slotSize: '97vw'
        }]),
        src: (normalizedMobileMedia === null || normalizedMobileMedia === void 0 ? void 0 : normalizedMobileMedia.imageUrl) || mobileImageUrl
      };
    }
    if (normalizedDesktopMedia !== null && normalizedDesktopMedia !== void 0 && normalizedDesktopMedia.videoUrl) {
      var _normalizedDesktopMed;
      var isAdaptive = normalizedDesktopMedia === null || normalizedDesktopMedia === void 0 ? void 0 : (_normalizedDesktopMed = normalizedDesktopMedia.videoUrl) === null || _normalizedDesktopMed === void 0 ? void 0 : _normalizedDesktopMed.includes('.m3u8');
      videoProps = _objectSpread({
        videoUrl: normalizedDesktopMedia === null || normalizedDesktopMedia === void 0 ? void 0 : normalizedDesktopMedia.videoUrl,
        landscapeAdaptiveSource: isAdaptive ? normalizedDesktopMedia === null || normalizedDesktopMedia === void 0 ? void 0 : normalizedDesktopMedia.videoUrl : null,
        landscapePosterImageProps: {
          src: normalizedDesktopMedia === null || normalizedDesktopMedia === void 0 ? void 0 : normalizedDesktopMedia.videoPreviewImageUrl,
          maxWidth: MAX_WIDTH,
          sizes: IMAGE_SIZES
        }
      }, (normalizedDesktopMedia === null || normalizedDesktopMedia === void 0 ? void 0 : normalizedDesktopMedia.autoplay) === false && {
        allowAudio: true,
        allowFullscreen: true,
        type: 'inline',
        captionProps: {
          src: normalizedDesktopMedia.videoCaptionsUrl,
          srcLang: srcLang
        }
      });
    }
    if (normalizedMobileMedia !== null && normalizedMobileMedia !== void 0 && normalizedMobileMedia.videoUrl) {
      var _normalizedMobileMedi;
      var _isAdaptive = normalizedMobileMedia === null || normalizedMobileMedia === void 0 ? void 0 : (_normalizedMobileMedi = normalizedMobileMedia.videoUrl) === null || _normalizedMobileMedi === void 0 ? void 0 : _normalizedMobileMedi.includes('.m3u8');
      mobileVideoProps = _objectSpread({
        videoUrl: normalizedMobileMedia === null || normalizedMobileMedia === void 0 ? void 0 : normalizedMobileMedia.videoUrl,
        landscapeAdaptiveSource: _isAdaptive ? normalizedMobileMedia === null || normalizedMobileMedia === void 0 ? void 0 : normalizedMobileMedia.videoUrl : null,
        landscapePosterImageProps: {
          src: normalizedMobileMedia === null || normalizedMobileMedia === void 0 ? void 0 : normalizedMobileMedia.videoPreviewImageUrl,
          maxWidth: MAX_WIDTH,
          sizes: IMAGE_SIZES
        }
      }, (normalizedMobileMedia === null || normalizedMobileMedia === void 0 ? void 0 : normalizedMobileMedia.autoplay) === false && {
        allowAudio: true,
        allowFullscreen: true,
        type: 'inline',
        captionProps: {
          src: normalizedMobileMedia.videoCaptionsUrl,
          srcLang: srcLang
        }
      });
    }
    if (callToAction) {
      var _callToAction$sys, _callToAction$sys$con, _callToAction$sys$con2;
      var ctaSysId = callToAction === null || callToAction === void 0 ? void 0 : (_callToAction$sys = callToAction.sys) === null || _callToAction$sys === void 0 ? void 0 : (_callToAction$sys$con = _callToAction$sys.contentType) === null || _callToAction$sys$con === void 0 ? void 0 : (_callToAction$sys$con2 = _callToAction$sys$con.sys) === null || _callToAction$sys$con2 === void 0 ? void 0 : _callToAction$sys$con2.id;
      if (ctaSysId === 'link') {
        var _callToAction$fields, _callToAction$fields2;
        ctaText = callToAction === null || callToAction === void 0 ? void 0 : (_callToAction$fields = callToAction.fields) === null || _callToAction$fields === void 0 ? void 0 : _callToAction$fields.callToAction;
        webRoute = callToAction === null || callToAction === void 0 ? void 0 : (_callToAction$fields2 = callToAction.fields) === null || _callToAction$fields2 === void 0 ? void 0 : _callToAction$fields2.webRoute;
      } else if (ctaSysId === 'webComponentModalLink') {
        callToAction.fields.classes = {
          modalLinkContainer: 'lll-text-body-2',
          modalLinkText: 'lll-text-body-2'
        };
        ctaLinkAs = renderContentfulComponent({
          contentfulComponent: callToAction,
          parents: [contentfulComponent]
        });
      }
    }
    return /*#__PURE__*/React.createElement(Card, {
      aspectRatio: aspectRatio,
      ctaLinkAs: ctaLinkAs,
      ctaText: ctaText,
      ctaURL: webRoute,
      heading: title,
      imageProps: imageProps && _objectSpread({}, imageProps),
      mobileAspectRatio: "landscape",
      mobileImageProps: mobileImageProps && _objectSpread({}, mobileImageProps),
      mobileVideoProps: mobileVideoProps && _objectSpread({}, mobileVideoProps),
      subContent: description,
      videoProps: videoProps && _objectSpread({}, videoProps)
    });
  },
  webCtaBlock: _ref9 => {
    var {
      data: {
        title,
        subtitle,
        webRoute,
        imageProps
      },
      children
    } = _ref9;
    return /*#__PURE__*/React.createElement(CTABlock, {
      heading: title,
      subContent: subtitle,
      href: webRoute,
      imageProps: imageProps
    }, children);
  },
  container: _ref10 => {
    var {
      data,
      children
    } = _ref10;
    return /*#__PURE__*/React.createElement(GridContainer, data, children);
  },
  gridLayout1Column: _ref11 => {
    var {
      contentfulComponent,
      data: {
        alignment = '',
        layoutOptions,
        heading
      },
      children,
      options,
      parents = []
    } = _ref11;
    return /*#__PURE__*/React.createElement(GridContainer, {
      align: alignment ? alignment.toLowerCase() : undefined,
      layout: layoutOptions,
      heading: (heading === null || heading === void 0 ? void 0 : heading.fields) && renderContentfulComponent({
        contentfulComponent: heading,
        options,
        parents: [...parents, contentfulComponent]
      })
    }, children);
  },
  gridLayout2Column: _ref12 => {
    var {
      contentfulComponent,
      data: {
        alignment = '',
        layoutOptions,
        heading,
        componentsLeft,
        componentsRight
      },
      options,
      parents = []
    } = _ref12;
    return /*#__PURE__*/React.createElement(GridContainer, {
      align: alignment ? alignment.toLowerCase() : undefined,
      layout: layoutOptions,
      heading: (heading === null || heading === void 0 ? void 0 : heading.fields) && renderContentfulComponent({
        contentfulComponent: heading,
        options,
        parents: [...parents, contentfulComponent]
      })
    }, [componentsLeft, componentsRight].map((column, index) => column.map(component => {
      var _component$sys;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: "2-column-".concat(index, "-").concat(component === null || component === void 0 ? void 0 : (_component$sys = component.sys) === null || _component$sys === void 0 ? void 0 : _component$sys.id)
      }, renderContentfulComponent({
        contentfulComponent: component,
        options,
        parents: [...parents, contentfulComponent]
      }));
    })));
  },
  gridLayout3Column: _ref13 => {
    var {
      contentfulComponent,
      data: {
        alignment = '',
        heading,
        componentsLeft,
        componentsMiddle,
        componentsRight
      },
      options,
      parents = []
    } = _ref13;
    return /*#__PURE__*/React.createElement(GridContainer, {
      align: alignment ? alignment.toLowerCase() : undefined,
      layout: "3 Columns",
      heading: (heading === null || heading === void 0 ? void 0 : heading.fields) && renderContentfulComponent({
        contentfulComponent: heading,
        options,
        parents: [...parents, contentfulComponent]
      })
    }, [componentsLeft, componentsMiddle, componentsRight].map((column, index) => column.map(component => {
      var _component$sys2;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: "3-column-".concat(index, "-").concat(component === null || component === void 0 ? void 0 : (_component$sys2 = component.sys) === null || _component$sys2 === void 0 ? void 0 : _component$sys2.id)
      }, renderContentfulComponent({
        contentfulComponent: component,
        options,
        parents: [...parents, contentfulComponent]
      }));
    })));
  },
  promoCardCollection: _ref14 => {
    var {
      contentfulComponent,
      data: {
        layoutOptions,
        heading
      },
      children,
      parents = [],
      options
    } = _ref14;
    return /*#__PURE__*/React.createElement(GridContainer, {
      layout: layoutOptions,
      heading: (heading === null || heading === void 0 ? void 0 : heading.fields) && renderContentfulComponent({
        contentfulComponent: heading,
        options,
        parents: [...parents, contentfulComponent]
      }),
      renderAsList: true
    }, children);
  },
  heading: _ref15 => {
    var {
      data: {
        subtitle,
        title,
        webHeadingStyle,
        webHeadingLevel,
        showLineAccent,
        headerId
      }
    } = _ref15;
    if (!webHeadingLevel) return null;
    var hdgClass = webHeadingStyle ? "lll-text-".concat(webHeadingStyle) : null;
    return /*#__PURE__*/React.createElement(Heading, {
      className: hdgClass,
      tag: webHeadingLevel,
      subHeading: subtitle,
      showLineAccent: showLineAccent,
      id: headerId
    }, title);
  },
  iconList: _ref16 => {
    var {
      contentfulComponent,
      data: {
        headingLvl,
        children
      },
      options,
      parents = []
    } = _ref16;
    return /*#__PURE__*/React.createElement(IconList, {
      headingLvl: headingLvl
    }, children.map(child => renderContentfulComponent({
      contentfulComponent: child,
      options,
      parents: [...parents, contentfulComponent]
    })));
  },
  iconListDetailedItem: (_ref17, options) => {
    var {
      data: {
        icon,
        heading,
        body
      }
    } = _ref17;
    return /*#__PURE__*/React.createElement(IconListDetailedItem, {
      heading: heading,
      icon: /*#__PURE__*/React.createElement(DynamicIcon, {
        name: icon,
        title: icon
      })
    }, renderContentType.richTextBody({
      data: {
        body
      },
      options
    }));
  },
  image: _ref18 => {
    var {
      data: {
        imageUrl,
        imageDescription
      }
    } = _ref18;
    return /*#__PURE__*/React.createElement(Image, {
      alt: imageDescription,
      block: true,
      src: imageUrl,
      tag: "div"
    });
  },
  responsiveImage: _ref19 => {
    var {
      data: {
        imageUrl,
        description,
        mobileImageUrl
      }
    } = _ref19;
    return /*#__PURE__*/React.createElement(Image, {
      alt: description,
      block: true,
      mobileSrc: mobileImageUrl,
      src: imageUrl,
      tag: "div"
    });
  },
  launchFullscreenVideo: _ref20 => {
    var {
      data: {
        fullscreenVideo,
        ctaText
      },
      options
    } = _ref20;
    return /*#__PURE__*/React.createElement(LaunchFullscreenVideo, {
      trigger: /*#__PURE__*/React.createElement(Button, null, ctaText)
    }, renderContentfulComponent({
      contentfulComponent: fullscreenVideo,
      options
    }));
  },
  link: _ref21 => {
    var {
      data
    } = _ref21;
    if (data.linkAttributes == null) {
      data.linkAttributes = {
        openNewWindow: false,
        rel: []
      };
    }
    var {
      callToAction,
      linkAttributes: {
        openNewWindow,
        rel = []
      },
      webRoute
    } = data;
    return /*#__PURE__*/React.createElement(LinkGenerator, {
      href: webRoute,
      rel: rel.length ? rel.join(' ') : null,
      target: openNewWindow ? '_blank' : null
    }, callToAction);
  },
  mediaActionBlock: _ref22 => {
    var {
      contentfulComponent,
      data: {
        body,
        ctaButton,
        heading,
        media,
        secondaryButton
      },
      options,
      parents = []
    } = _ref22;
    var {
      imageDescription,
      imageUrl,
      mobileImageUrl,
      videoUrl,
      videoCaptionsUrl
    } = (media === null || media === void 0 ? void 0 : media.fields) || {};
    return /*#__PURE__*/React.createElement(MediaActionBlock, {
      body: body,
      ctaButton: renderContentfulComponent({
        contentfulComponent: ctaButton,
        options,
        parents: [...parents, contentfulComponent]
      }),
      heading: heading,
      imageProps: imageUrl && {
        alt: imageDescription || '',
        mobileSrc: mobileImageUrl,
        src: imageUrl
      },
      secondaryButton: (secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.fields) && renderContentfulComponent({
        contentfulComponent: secondaryButton,
        options,
        parents: [...parents, contentfulComponent]
      }),
      videoProps: videoUrl && {
        videoUrl,
        videoCaptionsUrl
      }
    });
  },
  productCarousel: _ref23 => {
    var {
      data: {
        title,
        productIds,
        callToAction,
        webRoute,
        onProductClick
      }
    } = _ref23;
    return /*#__PURE__*/React.createElement(ProductCarousel, {
      title: title,
      productIds: productIds,
      callToAction: callToAction,
      webRoute: webRoute,
      onProductClick: onProductClick
    });
  },
  pullQuote: (_ref24, options) => {
    var {
      data: {
        attribution,
        attributionDisclosure,
        attributionHref,
        attributionSubtitle,
        text,
        variant
      }
    } = _ref24;
    return /*#__PURE__*/React.createElement(Quote, {
      attribution: attribution,
      attributionDisclosure: attributionDisclosure,
      attributionHref: attributionHref,
      attributionSubtitle: attributionSubtitle,
      variant: variant
    }, documentToReactComponents(text, options));
  },
  richTextBody: _ref25 => {
    var {
      data: {
        body
      },
      options
    } = _ref25;
    return /*#__PURE__*/React.createElement(RichText, {
      body: body,
      options: options
    });
  },
  webTable: _ref26 => {
    var {
      data: {
        columnHeading,
        rows
      }
    } = _ref26;
    return /*#__PURE__*/React.createElement(Table, {
      columnHeading: columnHeading,
      rows: rows
    });
  },
  webTabpanel: _ref27 => {
    var {
      data: {
        subtitle,
        title
      },
      children
    } = _ref27;
    return /*#__PURE__*/React.createElement(Tabpanel, {
      subtitle: subtitle,
      title: title
    }, children);
  },
  webTabpanelPanel: _ref28 => {
    var {
      data: {
        title,
        entryId
      },
      children
    } = _ref28;
    return /*#__PURE__*/React.createElement(TabpanelPanel, {
      label: title,
      id: entryId,
      key: entryId
    }, children);
  },
  video: _ref29 => {
    var {
      data: {
        autoplay,
        portraitVideoPreviewImageUrl,
        portraitVideoUrl,
        title,
        videoPreviewImageUrl,
        videoUrl
      }
    } = _ref29;
    var playerType = autoplay ? 'autoplay' : 'inline';
    var srcType = videoUrl.includes('.m3u8') ? 'adaptive' : 'standard';
    return /*#__PURE__*/React.createElement(ForwardedRefVideoPlayer, {
      allowAudio: playerType === 'inline',
      allowFullscreen: playerType === 'inline',
      analyticsTitle: title,
      landscapeSource: srcType === 'standard' ? videoUrl : null,
      landscapeAdaptiveSource: srcType === 'adaptive' ? videoUrl : null,
      landscapePosterImageProps: {
        alt: '',
        lazy: true,
        maxWidth: 1300,
        src: videoPreviewImageUrl
      },
      portraitSource: srcType === 'standard' ? portraitVideoUrl : null,
      portraitAdaptiveSource: srcType === 'adaptive' ? portraitVideoUrl : null,
      portraitPosterImageProps: portraitVideoPreviewImageUrl ? {
        alt: '',
        lazy: true,
        maxWidth: 1300,
        src: portraitVideoPreviewImageUrl
      } : null,
      type: playerType
    });
  },
  pill: _ref30 => {
    var {
      data: {
        icon,
        kind,
        text
      }
    } = _ref30;
    return /*#__PURE__*/React.createElement(Pill, _extends({
      kind: kind
    }, icon && {
      iconProps: {
        icon: /*#__PURE__*/React.createElement(DynamicIcon, {
          name: icon,
          title: icon
        }),
        position: 'left' // defaults to left, can make this dynamic later on if needed
      }
    }), text);
  },
  webFootnote: _ref31 => {
    var _body$content;
    var {
      data: {
        body,
        textAlign
      }
    } = _ref31;
    return /*#__PURE__*/React.createElement(Footnote, textAlign && {
      className: "lll-text-".concat(textAlign)
    }, body === null || body === void 0 ? void 0 : (_body$content = body.content) === null || _body$content === void 0 ? void 0 : _body$content.map(item => {
      return documentToReactComponents(item);
    }));
  },
  webNotification: _ref32 => {
    var {
      data: {
        type,
        icon,
        body
      }
    } = _ref32;
    return /*#__PURE__*/React.createElement(Notification, _extends({}, icon && {
      icon: /*#__PURE__*/React.createElement(DynamicIcon, {
        name: icon,
        title: icon
      })
    }, {
      type: type,
      visible: true
    }), documentToReactComponents(body));
  }
};

// Mapping of pattern library components to contentful content types
// This is used to dynamically insert documentation into the pattern library
export var contentfulModelMap = {
  Accordion: ['webAccordion'],
  AccordionItem: ['webAccordionItem'],
  BrandStatement: ['brandStatement'],
  Button: ['webButton'],
  CampaignHero: ['campaignHero'],
  Card: ['webPromoCard'],
  CTABlock: ['webCtaBlock'],
  GridContainer: ['container', 'gridLayout1Column', 'gridLayout2Column', 'gridLayout3Column', 'promoCardCollection'],
  Heading: ['heading'],
  IconList: ['iconList'],
  IconListDetailedItem: ['iconListDetailedItem'],
  Image: ['image', 'responsiveImage'],
  LaunchFullscreenVideo: ['launchFullscreenVideo'],
  LinkGenerator: ['link'],
  MediaActionBlock: ['mediaActionBlock'],
  ModalLink: ['webComponentModalLink'],
  ProductCarousel: ['productCarousel'],
  Quote: ['pullQuote'],
  RichText: ['richTextBody'],
  Table: ['webTable'],
  Tabpanel: ['webTabpanel'],
  TabpanelPanel: ['webTabpanelPanel'],
  VideoPlayer: ['video'],
  Pill: ['pill'],
  Footnote: ['webFootnote'],
  Notification: ['webNotification']
};